import React from "react";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import DetailsCard from "./DetailsCard";

const SubsectionsCard: React.FC<{
  title: string;
  content: ({ content: React.ReactNode; title?: React.ReactNode } | null)[];
  disableCardGutters?: boolean;
}> = ({ title, content, disableCardGutters = false }) => {
  return (
    <DetailsCard cardTitle={title} enableContentHiding>
      <Stack spacing={2} pb={1}>
        {content
          .filter((c) => c != null)
          .map((row, index) => (
            <Grid container key={index}>
              {row!.title != null && (
                <Grid item xs={12}>
                  {row!.title}
                </Grid>
              )}

              <Grid item xs={12}>
                {row!.content}
              </Grid>

              {index !== content.filter((c) => c != null).length - 1 && (
                <Grid item xs={12} sx={{ py: 1 }}>
                  <Divider variant="middle" />
                </Grid>
              )}
            </Grid>
          ))}
      </Stack>
    </DetailsCard>
  );
};

export default SubsectionsCard;
